import * as React from "react";
import { Collapse, Select } from "antd";
import styled from "styled-components";
import { useSelector } from "react-redux";
import update from "immutability-helper";
import { IState, ThemeContext } from "../../../../../themeDesigner";

const Panel = Collapse.Panel;

const { Option } = Select;

function callback(key) {
  console.log(key);
}

export interface ISpacingPropertiesProps {}

const Container = styled.div`
  margin-top: 14px;
`;

const Input = styled.input`
  width: ${(props) => props.theme.width}px;
  height: 28px;
  border-radius: 5px;
  border: 1px solid #d3daef;
  font-family: Muli;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacingproperties: normal;
  text-align: left;
  color: #010f34;
  padding: 0 8px;

  &:focus {
    outline: 1px solid ${(props) => props.theme.outlineColor};
  }
`;

const AllWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  .text {
    flex: 1;
    font-family: Muli;
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #7f90af;
  }
`;

const MarginWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${(props) => props.theme.marginBottom}px;
  justify-content: space-between;
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-family: Muli;
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.23;
    letter-spacing: normal;
    text-align: left;
    color: #7f90af;
  }
`;

export default function SpacingProperties(props: ISpacingPropertiesProps) {
  const { secondaryColor: outlineColor } = useSelector(
    (state: IState) => state.ui.theme
  );
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const {
    widget: { userInput: spacing },
  } = themeProps;
  const handleChange = (value: string, property: string) => {
    const updatedInput = update(themeProps, {
      widget: {
        userInput: {
          [property]: { $set: value },
        },
      },
    });
    setThemeProps(updatedInput);
  };
  return (
    <Collapse defaultActiveKey={["1"]} onChange={callback}>
      <Panel header="Spacing" key="1">
        <AllWrapper>
          <span className="text">Margin</span>
          <Input
            theme={{ outlineColor, width: 147 }}
            value={spacing.margin}
            onChange={(e) => handleChange(e.target.value, "margin")}
          />
        </AllWrapper>
        <MarginWrapper theme={{ marginBottom: 14 }}>
          <ColumnWrapper>
            <label>Right</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.marginRight}
              onChange={(e) => handleChange(e.target.value, "marginRight")}
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <label>Left</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.marginLeft}
              onChange={(e) => handleChange(e.target.value, "marginLeft")}
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <label>Top</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.marginTop}
              onChange={(e) => handleChange(e.target.value, "marginTop")}
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <label>Bottom</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.marginBottom}
              onChange={(e) => handleChange(e.target.value, "marginBottom")}
            />
          </ColumnWrapper>
        </MarginWrapper>
        <AllWrapper>
          <span className="text">Padding</span>
          <Input
            theme={{ outlineColor, width: 147 }}
            value={spacing.padding}
            onChange={(e) => handleChange(e.target.value, "padding")}
          />
        </AllWrapper>
        <MarginWrapper theme={{ marginBottom: 0 }}>
          <ColumnWrapper>
            <label>Right</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.paddingRight}
              onChange={(e) => handleChange(e.target.value, "paddingRight")}
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <label>Left</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.paddingLeft}
              onChange={(e) => handleChange(e.target.value, "paddingLeft")}
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <label>Top</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.paddingTop}
              onChange={(e) => handleChange(e.target.value, "paddingTop")}
            />
          </ColumnWrapper>
          <ColumnWrapper>
            <label>Bottom</label>
            <Input
              theme={{ outlineColor, width: 45 }}
              value={spacing.paddingBottom}
              onChange={(e) => handleChange(e.target.value, "paddingBottom")}
            />
          </ColumnWrapper>
        </MarginWrapper>
      </Panel>
    </Collapse>
  );
}
